import { render, staticRenderFns } from "./recruitDs.vue?vue&type=template&id=52a7e17a&"
import script from "./recruitDs.vue?vue&type=script&lang=js&"
export * from "./recruitDs.vue?vue&type=script&lang=js&"
import style0 from "./recruitDs.vue?vue&type=style&index=0&id=52a7e17a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports